import React from 'react';

import BaySpinner from '../BaySpinner';

interface LoadingProps {
	className?: string;
	message?: string;
}

// DEPRECATED: This component is no longer used in the application
// This component is used to display a loading spinner, we should
// use the BaySpinner component or the BayLoader component instead
export const Loading: React.FC<LoadingProps> = (props) => {
	return (
		<div className={props.className}>
			<BaySpinner title={props.message || 'Loading'} />
		</div>
	);
};
